import React from "react";
import templates from "./collection-templates";
// import { TaboolaAd } from "./atoms/taboola-ad";
import { DfpAd } from "./atoms/dfp-ad";

// const taboolaAdConfig = {
//   home: {
//     mode: "thumbnails-g",
//     id: "taboola-below-article-thumbnails",
//     placement: "Below Article Thumbnails"
//   },
//   section: {
//     mode: "thumbnails-h",
//     id: "taboola-mid-main-column-thumbnails---category",
//     placement: "Mid Main Column Thumbnails - Category"
//   }
// };

function wrapTemplateWithAds(Template, pagetype) {
  return function AdWrappedTemplate(props) {
    return (
      <React.Fragment>
        {/* {props.index === 2 && <TaboolaAd config={taboolaAdConfig[pagetype]} />} */}
        {props.index > 2 && props.index % 2 === 0 && <DfpAd adtype="Leaderboard" placement={pagetype} />}
        <Template {...props} pagetype={pagetype} />
      </React.Fragment>
    );
  };
}

export function addAdsToTemplates(pagetype) {
  let newTemplates = { ...templates };
  for (const templateKey in newTemplates) {
    if (newTemplates.hasOwnProperty(templateKey)) {
      newTemplates[templateKey] = wrapTemplateWithAds(newTemplates[templateKey], pagetype);
    }
  }
  return newTemplates;
}

export function getCollectionTemplate(designTemplate) {
  return templates[designTemplate] || templates.defaultTemplate;
}
